// local storage 缓存key
export const storageKey = {
  "userInfo": "USER_INFO",
  /** 锚点Id */
  "anchorId": "ANCHOR_ID",
  /** 首页-订购业务-tab value */
  "homeOrderTabValue": "HOME_ORDER_TAB_VALUE",
}

export const set = (key, value) => {
  const val = value ? JSON.stringify(value) : "";
  localStorage.setItem(key, val);
}

export const get = (key) => {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : "";
}

export const remove = (key) => {
  localStorage.removeItem(key);
}

export const sessionSet = (key, value) => {
  const val = value ? JSON.stringify(value) : "";
  sessionStorage.setItem(key, val);
}

export const sessionGet = (key) => {
  const value = sessionStorage.getItem(key);
  return value ? JSON.parse(value) : "";
}

export const sessionClear = () => {
  sessionStorage.clear();
}